import {api} from '../utils/environment'
import http from '../utils/http'

export async function readUserList(customerId: string) {
  const url = `${api}/user_list?customer_id=${customerId}`
  return await http.get(url)
}
